export default __webpack_public_path__ + "static/media/icConfirmation.0b0f0b06.svg";